module.exports = __webpack_public_path__ + "img/ocean.0ac06b67.jpg";